import API from '@/services/api.service'

const VenueAPI = {
  get () {
    return API.get('info').catch(error => {
      return Promise.reject(error.response)
    })
  }
}

export default VenueAPI
